import { twMerge } from 'tailwind-merge';

interface IStepProps {
  progress: number;
}

const Step = ({ progress }: IStepProps) => {
  return (
    <div className="flex-1 rounded-2xl h-[5px] bg-secondary-200">
      <div
        className="bg-primary-500 h-full rounded-2xl"
        style={{
          width: `${progress}%`,
        }}
      />
    </div>
  );
};

interface IProps {
  activeStep: number;
  totalSteps: number;
  activeSubStep: number;
  totalSubSteps: number;
  title?: string;
  subTitle?: string;
  className?: string;
}

export interface IProgressIndicatorProps extends IProps {}

const Stepper = ({
  activeStep,
  totalSteps,
  activeSubStep,
  totalSubSteps,
  title,
  subTitle,
  className,
}: IProps) => {
  const subtitle =
    totalSubSteps === 0 ? `Step (${activeStep}/${totalSteps})` : subTitle;

  return (
    <div
      className={twMerge('flex flex-col items-stretch w-full gap-2', className)}
    >
      <div className="flex max-w-full sm:max-w-[290px] w-full gap-1">
        {[...Array(totalSteps)].map((_, index) => {
          const currentStep = index + 1;
          let progress = 0;
          if (currentStep < activeStep) {
            progress = 1;
          } else if (currentStep === activeStep) {
            if (activeSubStep === 0) {
              progress = 0.075;
            } else {
              progress = activeSubStep / totalSubSteps;
            }
          }
          progress = parseFloat(progress.toFixed(2)) * 100;
          return <Step key={currentStep} progress={progress} />;
        })}
      </div>
      {(title != null || subTitle != null) && (
        <div className="flex items-center cursor-default gap-1">
          <p className="text-gray-500 font-semibold text-sm">{title}</p>
          {subtitle ? (
            <>
              <p className="text-gray-300 text-sm">•</p>
              <p className="text-gray-500 text-sm">{subtitle}</p>
            </>
          ) : null}
        </div>
      )}
    </div>
  );
};

export default Stepper;
